
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M9 14.8c.464 0 .84-.53.84-1.185v-9.23C9.84 3.731 9.464 3.2 9 3.2c-.464 0-.84.53-.84 1.185v9.23c0 .655.376 1.185.84 1.185z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M9 0C4.04 0 0 4.04 0 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 1.688A7.3 7.3 0 0116.312 9 7.3 7.3 0 019 16.313 7.3 7.3 0 011.688 9 7.3 7.3 0 019 1.688z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    